<template>
  <div class="convention-hall page">
    <div class="nav-bar newnavbar van-nav-bar van-hairline--bottom">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left">
          <span style="font-size: 16px; color: rgb(255, 255, 255); display: none;">届ける</span>
        </div>
        <div class="van-nav-bar__title van-ellipsis">
          <div class="menu-item-icon van-image" style="height: 40px; margin: 10px 0px 0px;">
            {{ $t("choose.title") }}
          </div>
        </div>
        <div class="van-nav-bar__right">
        </div>
      </div>
    </div>
    <div class="convention-item" style="padding-bottom: 24vw;">
      <div class="van-tabs van-tabs--line">
      <van-tabs v-model="active" animated swipeable @change="OnChange">
        <van-tab v-for="(v,key) in addlist" :key="key" :title="v" :name="key"></van-tab>
      </van-tabs>
      <div class="van-tabs__content van-tabs__content--animated">
        <div class="van-tabs__track" style="transform: translate3d(0%, 0px, 0px); transition-duration: 0.3s;">
          <div role="tabpanel" class="van-tab__pane-wrapper" v-if="active == 0">
            <div class="van-tab__pane">
              <div class="card">{{$t("choose.rule")}}
              </div>
              <div class="address">
                <div class="van-cell-group van-hairline--top-bottom"   v-for="(v,key) in datalist" :key="key" @click="profile(v.id,v.name)">
                  <div class="van-cell">
                    <div class="van-cell__value van-cell__value--alone"> {{v.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div role="tabpanel" class="van-tab__pane-wrapper" v-if="active == 1">
            <div class="van-tab__pane">
              <div class="card">{{$t("choose.rule")}}
              </div>
              <div class="rig-box"><p class="rig-title">{{$t("choose.resource")}}</p>
                <p class="rig-content">{{$t("choose.character")}}</p>
                <p class="rig-title">{{$t("choose.scope")}}</p>
                <p class="rig-content">{{$t("choose.location")}}</p>
                <p class="rig-content">{{$t("location1")}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <!--    <div class="list" style="padding-bottom: 40.667vw">
          <div class="pblBox">
            <div  style="width: calc(50% - 5px);"  v-for="(v,key) in datalist" :key="key" @click="profile(v.id)">
              <div class="releaseItem">
                <div class="imgBox">
                  <div class="van-image" style="width: 100%; height: 100%;">
                    <img :src="v.img_url" class="van-image__img">
                  </div>
                  <span >
                      <i >{{$t("profile.fd")}}</i>
                    </span>
                  <div  class="infoBox">
                    <i  class="van-icon van-icon-location" style="font-size: 14px;"></i>
                    <span style="font-size: 12px; margin: 0px 0px 0px 2px;">{{ v.address }}</span>
                    <div  class="wantyuebtn">{{ $t("profile.yuyue") }}</div>
                  </div>
                </div>
                <div  class="tagBox" style="color: rgb(102, 102, 102);">{{ v.flag[0] }}</div>
                <div  class="di">
                  <div >
                    <span  style="display: inline-block; margin-right: 2px; width: 12px; height: 12px; border-radius: 50%; background: rgb(239, 186, 143);"></span>
                    <span >{{ v.xuanfei_name }}</span></div>
                  <div ><i  class="van-icon van-icon-like" style="color: rgb(220, 99, 161);"></i>
                    <span data-v-b46fb340="">{{ v.dianzan }}</span>
                  </div>
                </div>
              </div>
            </div>
    
          </div>
          <div class="van-empty" style="width: 100%; padding-top: 90px; color: rgb(0, 0, 0);" v-if="datalist.length == 0">
            <div class="van-empty__image" style="width: 50px; height: 50px;">
              <img src="/img/emptyData.png"></div>
            <p class="van-empty__description">{{ $t('msg.没有更多了') }}</p>
          </div>
    
        </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      xuanfeiguanggao: '',
      active: 0,
      datalist: [],
      addlist: [
        this.$t("profile.city"),
        this.$t("choose.price"),
      ],
      videoSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      baseInfo: []
    };
  },
  methods: {
    getAddress() {
      this.$http({
        method: 'get',
        url: 'address_list'
      }).then(res => {
        this.datalist = res.data;
      });
    },
    profile() {

      this.$toast(this.$t("choose_msg"));
      return false;
      //this.$router.push({path: '/list?id=' + id+'&name='+n});
    },
    /*profile(id,n) {

      this.$toast(this.$t("msg.余额不足，请联系客服充值！"));
      return false;
      //this.$router.push({path: '/list?id=' + id+'&name='+n});
    },*/
    OnChange() {
      this.videolist = [];
      this.number = 0;
      this.page = 0;
      this.count = 0;
      this.getVideoList();//获取视频列表
    },

    itemChange() {
      this.active = this.$refs.swiper.swiper.activeIndex
      //this.OnChange()
    },
   /* getVideoList() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: {id: this.active}
      }).then(res => {
        this.datalist = res.data;
      });
    },*/

    getChooseItem() {
      this.$http({
        method: 'get',
        url: 'base_choose'
      }).then(res => {
        if (res.code == 200) {
          this.xuanfeiguanggao = res.data.xuanfeiguanggao;
        }
      })
    },

    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {

        this.baseInfo = res.data;
      })
    }
  },
  created() {
   // this.getChooseItem();
    this.getAddress();
    this.OnChange();
    this.getBaseInfo();
  }
};
</script>

<style lang="less" scoped>
.van-tabs__content--animated {
  overflow: hidden;
}
.van-cell {
  padding: 4vw 2.933vw;
  font-size: 4vw;
  line-height: 4vw;
}
.van-tab--active {
  border-bottom: 0.667vw #775fd9 solid;
}

.releaseItem .tagBox {
  font-size: 3vw;
  margin: 5px 0;
}

.releaseItem .di {
  display: flex;
  justify-content: space-between;
  font-size: 3vw;
  color: #666;
}

.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 10px;
}

.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 1px solid #fff;
  padding: 5px 8px;
  border-radius: 8px;
  opacity: .9;
  font-size: 3vw;
  margin-left: auto;
}

.releaseItem .imgBox > span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}

.releaseItem .imgBox > span > i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}

.van-image__img {
  display: block;
  width: 100%;
  height: 100%;
}

.van-image {
  position: relative;
  display: inline-block;
}

.imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 67vw;
}

.releaseItem {
  width: 100%;
  margin-bottom: 15px;
}

.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  flex-wrap: wrap;
}

.van-col {
  padding: 2.333vw;
  float: none;
}

.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: #f2f2f5;
}

::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

.card {
  background-color: #8a637d;
  padding: 0.625rem;
  width: 95%;
  color: white;
  font-size: 0.8125rem;
  margin: 0.625rem auto;
  border-radius: 0.375rem;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}

.rig-box {
  width: 95%;
  margin: 0.625rem auto;
}

.rig-title {
  color: #0bdab0;
  font-size: 1.125rem;
}

.rig-content {
  font-size: 20px;
  // margin-top: 10px;
}

.address {
  width: 94%;
  margin: 0 auto;
}
</style>
